import { ApplicationStatus } from 'enums/ApplicationStatus';
import { ApplicationProductName } from 'enums/common.enums';
import { AutomatedOfferResult } from 'enums/ApplicationsVariables';
import { OfferDto } from 'api/OffersApi';
import { MIN_HIL_LOAN_AMOUNT_RANGE } from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/LoanAmount/loanAmount.constants';
import { CreateAccountView } from 'prequalificationV2/pages/SignInProcess/steps/CreateAccount/createAccount.enums';
import { GetCreateAccountViewParams } from 'prequalificationV2/pages/SignInProcess/steps/CreateAccount/createAccount.types';

const getPosCreateAccountView = (
  loanAmount?: number,
  posHighAmountOfferResult?: AutomatedOfferResult | null,
): CreateAccountView | null => {
  if ((loanAmount ?? 0) < MIN_HIL_LOAN_AMOUNT_RANGE) {
    return CreateAccountView.OfferAccepted;
  }

  if (posHighAmountOfferResult === AutomatedOfferResult.Accepted) {
    return CreateAccountView.OfferAccepted;
  }

  if (
    posHighAmountOfferResult === AutomatedOfferResult.Expired ||
    posHighAmountOfferResult === AutomatedOfferResult.Rejected
  ) {
    return CreateAccountView.OffersAvailable;
  }

  if (posHighAmountOfferResult === AutomatedOfferResult.FailedConditions) {
    return CreateAccountView.ManualNoOffers;
  }

  return null;
};

export const getCreateAccountView = ({
  hasAutomatedOffer,
  applicationStatus,
  productName,
  loanAmount,
  posHighAmountOfferResult,
}: GetCreateAccountViewParams): CreateAccountView | null => {
  if (productName === ApplicationProductName.SmallLoanProgram) {
    return getPosCreateAccountView(loanAmount, posHighAmountOfferResult);
  }

  const hasActiveOffer = applicationStatus === ApplicationStatus.Pitched;

  if (hasAutomatedOffer && hasActiveOffer) {
    return CreateAccountView.OfferAccepted;
  }

  if (hasActiveOffer || hasAutomatedOffer) {
    return CreateAccountView.OffersAvailable;
  }

  return CreateAccountView.ManualNoOffers;
};

export const getBorrowerFullNames = (
  borrowerFirstName?: string | null,
  borrowerLastName?: string | null,
  coBorrowerFirstName?: string | null,
  coBorrowerLastName?: string | null,
): string => {
  const borrowerName = `${borrowerFirstName ?? ''} ${borrowerLastName ?? ''}`.trim();
  const coBorrowerName = coBorrowerFirstName ? `${coBorrowerFirstName} ${coBorrowerLastName ?? ''}`.trim() : '';

  return coBorrowerName ? `${borrowerName} and ${coBorrowerName}` : borrowerName;
};

export const getLowestRate = (offers: OfferDto[]): number | undefined => {
  if (!offers.length) {
    return undefined;
  }

  return Math.min(...offers.map((offer) => offer.rate));
};
